 $(".recommend_tit, .recommend_content").click(function() {
    $('.recommend_content').toggleClass('show');
    });
    
      
    $('html').click(function(e) {   
    	if(!$(e.target).is('.recommend_tit, .recommend_content')){   
    		$('.recommend_content').removeClass('show');
    	}
    });

  function showPopup() {
    $('#subscriptionPopup').addClass('show');    
      $('.pageOverlay').addClass('on'); 
  }

  function closePopup(e) {
    const popup = $('#subscriptionPopup').removeClass('show');  
    e.stopPropagation();
    $('.pageOverlay').removeClass('on'); 
  }
  $("body").append("<div class='pageOverlay'></div>");
  
  let thumbs = [];
  let slideIndex = 1;
  showSlides(slideIndex);

  function slideNext() {
    if (showSlides(slideIndex + 1)) {
      slideThumbnailToRight(slideIndex + 1);
      slideIndex++;
    }
  }

  function slidePrev() {
    if (showSlides(slideIndex - 1)) {
      slideThumbnailToLeft(slideIndex - 1);
      slideIndex--;
    }
  }

  function slideThumbnailToRight(index) {
    const container = $('.subscription__popup-content-thumbnail-container')[0];
    const selectedThumbnail = $('.subscription__popup-content-thumbnail')[index - 1];

    if (container.offsetWidth < selectedThumbnail.offsetLeft + selectedThumbnail.offsetWidth) {
      console.log('scroll to: ', selectedThumbnail.offsetLeft + selectedThumbnail.offsetWidth - container.offsetWidth);
      container.scroll({ left: selectedThumbnail.offsetLeft + selectedThumbnail.offsetWidth - container.offsetWidth, behavior: 'smooth' });
    }
  }

  function slideThumbnailToLeft(index) {
    const container = $('.subscription__popup-content-thumbnail-container')[0];
    const selectedThumbnail = $('.subscription__popup-content-thumbnail')[index - 1];

    if (container.scrollLeft > selectedThumbnail.offsetLeft) {
      console.log('scroll to: ', selectedThumbnail.offsetLeft);
      container.scroll({ left: selectedThumbnail.offsetLeft, behavior: 'smooth' });
    }
  }
  
  // Thumbnail image controls
  function currentSlide(n) {
    showSlides(slideIndex = n);
  }
  
  function showSlides(n) {
    let i;
    let slides = $('.subscription__popup-content-main');
    if (n >= slides.length || n < 1) {
      return false;
    }
    
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slides[n-1].style.display = "block";
    
    $('.subscription__popup-content-thumbnail.selected').removeClass('selected');
    $('.subscription__popup-content-thumbnail').addClass(function(index) {
      if (index == n - 1) {
        return 'selected';
      } 

      return '';
    });

    return true;
  }